import _ from 'lodash'

const state = {
  headers: [],
  foldedHeaderLineNumbers: [],
  activeHeaderLineNumber: -1
}

const getters = {
  outline (state, getters, rootState) {
    let name = rootState.workbench.current.note.name
    if (/^\s*$/.test(name)) {
      name = '请输入笔记名称'
    }
    const outline = {
      name,
      root: true,
      items: [],
      level: 0,
      lineNumber: 0,
      empty: state.headers.length === 0
    }
    _.forEach(state.headers, n => {
      const parent = getParent(outline, n.level)
      const item = {
        level: n.level,
        name: n.text,
        items: [],
        parent,
        folded: _.indexOf(state.foldedHeaderLineNumbers, n.lineNumber) > -1,
        lineNumber: n.lineNumber,
        active: n.lineNumber === state.activeHeaderLineNumber,
        empty: n.empty
      }
      parent.items.push(item)
    })
    return outline
  },
  foldedHeaderLineNumbers (state) {
    return state.foldedHeaderLineNumbers
  },
  headers (state) {
    return state.headers
  }
}

const mutations = {
  SET_HEADERS (state, headers) {
    state.headers = headers
  },
  SET_ACTIVE_HEADER_LINENUMBER (state, activeHeaderLineNumber) {
    state.activeHeaderLineNumber = activeHeaderLineNumber
  },
  SET_FOLDED_HEADER_LINENUMBERS (state, foldedHeaderLineNumbers) {
    state.foldedHeaderLineNumbers = foldedHeaderLineNumbers
  },
  ADD_FOLDED_HEADER_LINENUMBER (state, foldedHeaderLineNumber) {
    if (state.foldedHeaderLineNumbers.indexOf(foldedHeaderLineNumber) === -1) {
      state.foldedHeaderLineNumbers.push(foldedHeaderLineNumber)
    }
  },
  REMOVE_FOLDED_HEADER_LINENUMBER (state, foldedHeaderLineNumber) {
    _.remove(state.foldedHeaderLineNumbers, n => n === foldedHeaderLineNumber)
    state.foldedHeaderLineNumbers = [...state.foldedHeaderLineNumbers]
  },
  RESET (state) {
    state.headers = []
    state.foldedHeaderLineNumbers = []
    state.activeHeaderLineNumber = -1
  }
}

const actions = {
}

function getParent (item, level, fallback = false) {
  if (level > item.level) {
    if (fallback) {
      return item
    }
    if (item.items.length > 0) {
      return getParent(item.items[item.items.length - 1], level)
    } else {
      return item
    }
  }

  if (level === item.level) {
    return item.parent
  }

  return getParent(item.parent, level, true)
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
